/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: 字体图表选择的模态框 
 * 使用说明: 参考 sw-icon-select 配置应用说明文档
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { SwModalframeComponent } from '../../basic-components/sw-modal-frame/sw-modal-frame.component';
declare var $: any;

/**
 * 字体图标弹出框 sw-icon-select
 */
@Component({
  selector: 'sw-icon-select',
  templateUrl: './icon-select.component.html',
  styleUrls: ['./icon-select.component.css']
})
export class IconSelectComponent implements OnInit {

  /**
   * 选择一条数据 抛出事件
   */
  @Output() Icon = new EventEmitter(); 

  /** 
   * @ignore
   * 弹出框组件
   */
  @ViewChild('swmodalframeIcon') swmodalframeIcon: SwModalframeComponent; 

  /**
    * 动态创建组件传入的参数, 要含有 userId 这个数组
    */
  @Input() param :any

  /**
    * 动态创建组件的抛出事件
    */
  @Output() callback = new EventEmitter(); 

  /**
   * 所有的字体图标
   * @ignore
   */
  icons:any[] = []

  /**
   * 所有的字体图标分类
   * @ignore
   */
  iconType:any = {}

  /**
   * 基础图标
   * @ignore
   */
  basicIcons:any[] = []
  

  /**
   * 功能图标
   * @ignore
   */
  functionIcons:any[] = []

  /** 
   * 选项卡数组
   * @ignore
   */
  tabControls:any[] = [{id:'1',text:'功能图标'},{id:'2',text:'基础图标'}]  

  /** 
   * 选项卡切换的结果
   * @ignore
   */
  tabControlResult:string  

  /** 
   * 搜索内容
   * @ignore
   */
  iconName:string = ""

  /** 
   * header部分一级模块菜单信息，为了根据 functionCode 对图标进行分类
   */
  allAreasModel:any[] = []


  /**
   * @ignore
   */
  constructor(
    private http:SwHttpClientService,
    private Areas: SwMenuService, //请求菜单服务
  ) { }

  /**
   * @ignore
   */
  ngOnInit() {
    
    this.allAreasModel = this.Areas.getAreasVal(); //所有菜单模块信息
    // console.log('this.allAreasModel',this.allAreasModel);
    
    this.http.Get('assets/fonticon/iconfont.json')
      .subscribe(data => {
        this.icons = data.glyphs
        this.icons.forEach(icon => {
          icon['class'] = 'icon iconfont icon'+ icon['font_class']
          let type = icon['font_class'].split('_')[0]
          if(this.iconType[type]){
            //如果已经存在此类别，就将此图标加进去
            this.iconType[type].push(icon)
          } else {
            //如果之前不存在，就直接先创建一个数组
            this.iconType[type] = [icon]
          }
        });
        for (let key in this.iconType) {
          if(key.toLocaleLowerCase() == 'btn'){
            //基础图标
            this.basicIcons = this.iconType[key]
          } else {
            //功能图标，就先根据 this.allAreasModel 中找到对应的菜单名称
            let menu = this.allAreasModel.find(v=>v.functionCode.toLocaleUpperCase() == key.toLocaleUpperCase())
            if(menu){
              //如果有这个菜单模块权限，就显示这个菜单模块的图标，否则不显示此模块的图标
            this.functionIcons.push({icons:this.iconType[key],type:key,functionName:menu.functionName}) 
            }
          }
        }
        setTimeout(() => {
          //打开模态框
          this.swmodalframeIcon.toggle();
          
        }, 0);
        // console.log('this.functionIcons',this.functionIcons);
        
      });
  }

  /**
   * 切换选项卡
   * @param data 
   * @ignore
   */
  ovtedTab(data){
    this.tabControlResult = data.id
  }

  /**
   * 搜索功能
   * @ignore
   */
  clickSelect() {
    let newFunctionIcons = []
    for (const key in this.iconType) { 
      if(key == 'btn'){
        //基础图标
        let list = this.iconType[key]
        let i = list[0]['name'].indexOf(this.iconName)
        this.basicIcons = list.filter(v=>v.name.indexOf(this.iconName) > -1)
        
      } else {
        //功能图标
        let list = this.iconType[key]
        let i = list[0]['name'].indexOf(this.iconName)
        let filterList = list.filter(v=>v.name.indexOf(this.iconName) > -1)
        //功能图标，就先根据 this.allAreasModel 中找到对应的菜单名称
        let menu = this.allAreasModel.find(v=>v.functionCode == key.toLocaleUpperCase())
        if(menu && filterList.length){
          //如果有这个菜单模块权限，就显示这个菜单模块的图标，否则不显示此模块的图标
          newFunctionIcons.push({icons:filterList,type:key,functionName:menu.functionName}) 
        }
      }
    }
    this.functionIcons = newFunctionIcons
    // console.log('this.functionIcons',this.functionIcons);
    
  }

  /**
   * 按钮点击事件
   * @param item 选中的图标
   * @ignore
   */
  clickIcon(item) {
    //选择一个图标抛出
    this.swmodalframeIcon.toggle(); //关闭模态框
    this.callback.emit(item.class)
  }
}
